
import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";
import SmartRecommendations from "./jimatbiz-order/SmartRecommendations";
import LetsOrder from "./jimatbiz-order/LetsOrder";
import PastOrders from "./jimatbiz-order/PastOrders";
import OrderCart from "./jimatbiz-order/OrderCart";
import PendingDeliveries from "./jimatbiz-order/PendingDeliveries";
import CreditSummary from "./jimatbiz-order/CreditSummary";
import { ShoppingCart } from "lucide-react";

const JimatbizOrder = () => {
  const [cartCount, setCartCount] = useState(0);
  
  const handleAddToCart = (quantity: number) => {
    setCartCount(prev => prev + quantity);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-green-700">Order - JiMATBiz</h1>
          <p className="text-muted-foreground">
            Place orders directly with JiMATBiz and manage your inventory efficiently
          </p>
        </div>
        <div className="relative">
          <ShoppingCart className="w-6 h-6 text-green-700" />
          {cartCount > 0 && (
            <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
              {cartCount}
            </span>
          )}
        </div>
      </div>
      
      <Tabs defaultValue="smart-recommendations" className="w-full">
        <TabsList className="grid grid-cols-6 mb-4">
          <TabsTrigger value="smart-recommendations">Smart Recommendations</TabsTrigger>
          <TabsTrigger value="lets-order">Let's Order</TabsTrigger>
          <TabsTrigger value="past-orders">Past Orders</TabsTrigger>
          <TabsTrigger value="order-cart">Order Cart</TabsTrigger>
          <TabsTrigger value="pending-deliveries">Pending Deliveries</TabsTrigger>
          <TabsTrigger value="credit-summary">Credit Summary</TabsTrigger>
        </TabsList>
        
        <Card className="border-green-100">
          <CardContent className="p-6">
            <TabsContent value="smart-recommendations" className="mt-0">
              <SmartRecommendations onAddToCart={handleAddToCart} />
            </TabsContent>
            
            <TabsContent value="lets-order" className="mt-0">
              <LetsOrder onAddToCart={handleAddToCart} />
            </TabsContent>
            
            <TabsContent value="past-orders" className="mt-0">
              <PastOrders />
            </TabsContent>
            
            <TabsContent value="order-cart" className="mt-0">
              <OrderCart cartCount={cartCount} setCartCount={setCartCount} />
            </TabsContent>
            
            <TabsContent value="pending-deliveries" className="mt-0">
              <PendingDeliveries />
            </TabsContent>
            
            <TabsContent value="credit-summary" className="mt-0">
              <CreditSummary />
            </TabsContent>
          </CardContent>
        </Card>
      </Tabs>
    </div>
  );
};

export default JimatbizOrder;
